<!-- =========================================================================================
  File Name: CalendarViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<popup-customize
		class="vs-popup--custom"
		:fullscreen="false"
		:title="null"
		:active="isSidebarActiveLocal"
		:hidden-boolean="true"
	>
		<div class="flex items-start justify-between">
			<bread-crumbs
				:title="$t('ResourceList')"
				:subTitle="$t('general.SubtitleResource')"
				:sizeTitle="22"
				:lineHeightTitle="27"
				:sizeSubTitle="13"
				:lineHeightSubTitle="16"
			>
			</bread-crumbs>
			<feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
		</div>
		<div class="p-6">
			<resource-list
				ref="ResourceList"
				title=""
				componentParent="RESOURCE_CALENDAR"
				:isActiveChatUser="false"
				v-if="isSidebarActiveLocal"
			/>
		</div>
	</popup-customize>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import DateUtils from "@/helpers/DateUtils.js";
import Commons from "@/helpers/commons.js";
import moduleResource from "@/store/resource/moduleResource.js";
import {BatteryChargingIcon, BatteryIcon} from "vue-feather-icons";
import ListTransmision from "./ListTransmision";
import ResourceList from "./ResourceList.vue";
import PopupCustomize from "../../core/components/PopupCustomize";

export default {
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true,
		},
	},
	components: {
		PopupCustomize,
		VuePerfectScrollbar,
		vSelect,
		ListTransmision,
		BatteryChargingIcon,
		BatteryIcon,
		ResourceList,
	},
	data() {
		return {
			resourcesDataLocal: [],
			searchQuery: null,
			viewType: "CARDS",
			popupActive: false,
			activeItem: 0,
			type: "Options",
			date_between_init: "",
			date_between_end: "",
			select1: "",
			selectedOption: "Schedule",
			batteryStatus: {
				alert: {
					icon: "battery_alert",
					color: "FEDEDE",
				},
				full: {
					icon: "battery_full",
					color: "FEDEDE",
				},
			},
			relatedIds: [],
			checkedResources: [],

			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 10,
		};
	},
	computed: {
		resourcesDataFilter() {
			const data = this.resourcesDataLocal;
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return r.name.toLowerCase().includes(this.searchQuery.toLowerCase());
			});
		},
		resourcesForSelect() {
			return this.resourcesDataLocal.map(({name, uid}) => {
				return {label: name, value: uid};
			});
		},
		resourcesData() {
			return this.resourcesDataLocal;
		},
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		today() {
			const f = new Date("Tue, 18 Mar 2025 19:35:52 GMT");
			return DateUtils.toDefaultDateTime(f, "YYYY-MM-DD");
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
	},
	methods: {
		// Event emit para recoger los recursos marcados en el componente Listado de recursos
		selectedResources(resorces) {
			this.checkedResources = resorces;
		},
		changeView(opc) {
			this.viewType = opc;
		},
		changeOptions(opc) {
			switch (opc) {
				case 1:
					this.selectedOption = "Visit Points";
					break;
				case 2:
					this.selectedOption = "Schedule";
					break;
				case 3:
					this.selectedOption = "Route";
					break;

				default:
					break;
			}
		},
		toggleDataSidebar(val = false) {
			this.$emit("closeSidebar");
		},
		closePopup() {
			this.popupActive = false;
		},
		openExportPopup() {
			this.popupActive = true;
		},
		getResources() {
			Commons.openLoadingDiv.call(this, "div-resource-calendar-loading");
			const dataPage = {
				page: this.currentPage,
				quantity: this.quantityElementPage,
			};
			this.$store
				.dispatch("moduleResource/fetchResourceFilter", dataPage, {
					component: "map",
				})
				.then((res) => {
					this.resourcesDataLocal = res.data.records;
					Object.assign(this.pagination, res.data.pagination);
					Commons.closeLoadingDiv.call(this, "div-resource-calendar-loading");
				})
				.catch((err) => {
					Commons.closeLoadingDiv.call(this, "div-resource-calendar-loading");
					throw new Error(err);
				});
		},
	},
	watch: {
		itemsPerPage(val) {
			this.quantityElementPage = val;
			this.currentPage = 1;
		},
		currentPage(val) {
			this.getResources({
				page: this.currentPage,
				quantity: this.quantityElementPage,
			});
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
	mounted() {
		this.$vs.notify({
			time: 5000,
			title: this.$t("Resource.Resources"),
			text: this.$t("Schedule.SelectResourceText"),
			color: "primary",
			icon: "account_circle",
		});
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vuexy/pages/search.scss";

.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 51010;
		background-color: rgba(0, 0, 0, 0.7);
	}

	::v-deep .vs-sidebar {
		z-index: 51010;
		width: 35%;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}

.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.custom-class {
	color: #00ff00;
}
</style>
